import { useEffect } from 'react'
import { Navigate, Outlet, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth-store'

export function ProtectedRoute() {
  const { isAuthenticated, clearAuth } = useAuthStore()
  const navigate = useNavigate()

  // Não há mais checagem local de expiração do access token aqui: com o
  // refresh automático (RF05), um access token expirado é esperado durante a
  // navegação normal e é renovado de forma transparente na próxima chamada
  // autenticada (ver `src/services/api-client.ts` / `auth-refresh.ts`).
  // Redirecionar para `/login` só acontece quando o refresh de fato falha
  // (token de refresh inválido/expirado/reusado), sinalizado pelo evento
  // `navega:session-expired` abaixo — nunca mais a partir de uma checagem
  // local do JWT, que não sabe se o refresh token ainda é válido.
  useEffect(() => {
    function handleSessionExpired() {
      clearAuth()
      navigate('/login', { replace: true })
    }

    window.addEventListener('navega:session-expired', handleSessionExpired)
    return () => window.removeEventListener('navega:session-expired', handleSessionExpired)
  }, [clearAuth, navigate])

  if (!isAuthenticated) return <Navigate to="/login" replace />

  return <Outlet />
}
